import { useUserInfo } from "@/api/user";

/**
 * Returns true when the current user's org is on the server-provisioned
 * `beta` plan. Beta orgs have a fixed seat count and overage limit and
 * can't change those billing knobs from the dashboard — the backend
 * rejects the update with 403.
 *
 * Use this for beta-tier-specific UX (e.g. hiding the overage budget
 * form and the "Add Seats" capacity escalation). For UI that should be
 * hidden for any non-self-serve tier (enterprise + beta), use
 * {@link useIsSelfServeBilling}. For enterprise-only UX, use
 * {@link useEnterprisePlan}.
 */
export function useBetaPlan() {
  const { data: userInfo } = useUserInfo();
  return userInfo?.subscription?.plan_name === "beta";
}
